// Site copy in both languages. English is the default; Turkish is offered
// through the header switch. Keep the two objects structurally identical.
const translations = {
  en: {
    langName: "EN",
    switchTo: "Türkçe'ye geç",

    nav: {
      work: "Work",
      projects: "Projects",
      experiences: "Experiences",
      about: "About Me",
      skills: "Skills",
    },

    hero: {
      greeting: "I'm",
      available: "Available for work",
      location: "Istanbul, Turkey",
      role: ["SOFTWARE", "ENGINEER"],
      intro:
        "I build web and mobile products where the interface and the AI behind it are the same problem — from real-time dashboards to LLM-assisted workflows. Computer engineer, MSc in AI, shipping since 2021.",
      ctaWork: "See selected work",
      ctaContact: "Get in touch",
      srIntro:
        "Azat ESER is a software engineer and frontend developer based in Turkey, with more than five years of professional experience. He builds web and mobile products with React, Next.js, TypeScript and React Native, and integrates AI and LLM tooling into them. Available for work — contact azatesser@gmail.com.",
    },

    stats: {
      label: "At a glance",
      items: [
        { value: "5+", label: "years shipping", detail: "since 2021" },
        { value: "4", label: "countries", detail: "UK · SG · DE · TR" },
        { value: "8+", label: "products shipped", detail: "web & mobile" },
        { value: "MSc", label: "in AI", detail: "deep learning" },
      ],
    },

    work: {
      title: "Selected Work",
      subtitle: "Five products, and what actually changed after I worked on them.",
      problem: "The problem",
      whatIDid: "What I did",
      tablist: "Case studies",
    },

    experience: {
      years: "YEARS XP",
      title: "Professional Journey",
      subtitle:
        "From SaaS applications to websites & mobile apps, I've collaborated with diverse teams across various industries.",
    },

    contact: {
      title: "Contact",
      available: "Available for work",
      line: "Drop me a line or say",
      social: "on social networks",
      blurb:
        "If you're a frontend developer seeking assistance or a startup eager to enhance your user interface, I'm enthusiastic about discussing your project 💜",
    },

    sticky: {
      available: "Available for work",
      cta: "Get in touch",
      dismiss: "Dismiss",
    },

    github: {
      title: "Github Projects",
      titleShort: "Projects",
      all: "All Projects",
      web: "Web Projects",
      mobile: "Mobile Projects",
      viewDemo: "View Demo",
      descriptions: {
        "Markdown preview tool": "Markdown preview application",
        frontendMentor_Projects: "Frontend Mentor Challenge",
        "15-React-Project": "ReactJS",
        expo_Projects: "React Native",
        devChallenges: "devchallenges.io",
        "write-typing-game": "React JS",
        "fiverr-ui-clone": "React JS",
      },
    },

    skills: {
      title: "My Tech Stack",
      subtitle: "Exploring modern tools to create seamless, responsive digital experiences.",
    },
  },

  tr: {
    langName: "TR",
    switchTo: "Switch to English",

    nav: {
      work: "Çalışmalar",
      projects: "Projeler",
      experiences: "Deneyim",
      about: "Hakkımda",
      skills: "Yetenekler",
    },

    hero: {
      greeting: "Ben",
      available: "İş fırsatlarına açığım",
      location: "İstanbul, Türkiye",
      role: ["YAZILIM", "MÜHENDİSİ"],
      intro:
        "Arayüzün ve arkasındaki yapay zekânın aynı problem olduğu web ve mobil ürünler geliştiriyorum — gerçek zamanlı panellerden LLM destekli iş akışlarına. Bilgisayar mühendisi, yapay zekâ yüksek lisansı, 2021'den beri ürün geliştiriyorum.",
      ctaWork: "Çalışmalarımı gör",
      ctaContact: "İletişime geç",
      srIntro:
        "Azat ESER, Türkiye merkezli, beş yılı aşkın deneyime sahip bir yazılım mühendisi ve frontend geliştiricidir. React, Next.js, TypeScript ve React Native ile web ve mobil ürünler geliştirir, bunlara yapay zekâ ve LLM araçlarını entegre eder. İş fırsatlarına açıktır — azatesser@gmail.com.",
    },

    stats: {
      label: "Özet",
      items: [
        { value: "5+", label: "yıllık deneyim", detail: "2021'den beri" },
        { value: "4", label: "ülke", detail: "İN · SG · AL · TR" },
        { value: "8+", label: "ürün", detail: "web & mobil" },
        { value: "YL", label: "yapay zekâ", detail: "derin öğrenme" },
      ],
    },

    work: {
      title: "Seçilmiş Çalışmalar",
      subtitle: "Beş ürün ve üzerinde çalıştıktan sonra gerçekten neyin değiştiği.",
      problem: "Problem",
      whatIDid: "Ne yaptım",
      tablist: "Vaka çalışmaları",
    },

    experience: {
      years: "YIL DENEYİM",
      title: "Profesyonel Yolculuk",
      subtitle:
        "SaaS uygulamalarından web sitelerine ve mobil uygulamalara kadar, farklı sektörlerden ekiplerle birlikte çalıştım.",
    },

    contact: {
      title: "İletişim",
      available: "İş fırsatlarına açığım",
      line: "Bana yazın ya da sosyal medyadan",
      social: "merhaba deyin",
      blurb:
        "Yardıma ihtiyacı olan bir frontend geliştirici ya da arayüzünü geliştirmek isteyen bir girişimseniz, projenizi konuşmaktan memnuniyet duyarım 💜",
    },

    sticky: {
      available: "İş fırsatlarına açığım",
      cta: "İletişime geç",
      dismiss: "Kapat",
    },

    github: {
      title: "Github Projeleri",
      titleShort: "Projeler",
      all: "Tüm Projeler",
      web: "Web Projeleri",
      mobile: "Mobil Projeler",
      viewDemo: "Demoyu Gör",
      descriptions: {
        "Markdown preview tool": "Markdown önizleme uygulaması",
        frontendMentor_Projects: "Frontend Mentor görevleri",
        "15-React-Project": "ReactJS",
        expo_Projects: "React Native",
        devChallenges: "devchallenges.io",
        "write-typing-game": "React JS",
        "fiverr-ui-clone": "React JS",
      },
    },

    skills: {
      title: "Teknoloji Yığınım",
      subtitle:
        "Akıcı ve duyarlı dijital deneyimler üretmek için modern araçları kullanıyorum.",
    },
  },
};

export default translations;
